export const getCurrentSite = () => {
  const host = window.location.hostname;
  let site = "Auckland";
  if (host.indexOf("auckland") >= 0) {
    site = "Auckland";
  }
  return site;
};
